import { render } from "./VideoInfo.vue?vue&type=template&id=1d7985fe&scoped=true"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"

import "./VideoInfo.vue?vue&type=style&index=0&id=1d7985fe&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d7985fe"]])

export default __exports__